export default {"src":"/_next/static/media/captain.dfd87617.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};